<template>
  <div>
    <div class="grey lighten-5 input-container">
      <v-row>
        <v-col cols="12" md="3"></v-col>
        <v-col cols="12" md="3"></v-col>
        <v-col cols="12" md="3"></v-col>
        <v-col
          v-if="permissions.includes('CAN_EXPORT_DOCTOR_DATA_REPORTS')"
          cols="12"
          md="3"
        >
          <div class="mt-3 ml-4 text-end">
            <v-btn @click="downloadCsv()" :disabled="doctorList && doctorList.length === 0" class="btn btn-primary mr-4 mt-4"
              >Export</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <loader v-if="showLoader"></loader>
      <v-col cols="12" class="mt-2">
        <div class="table-div overflow-auto">
          <table class="table userlistTable small-table-width doctorwidth">
            <thead>
              <tr class="table-success">
                <th scope="col" class="min-width-130">Docsmart UUID</th>
                <th scope="col" class="min-width-130">Full Name</th>
                <th scope="col">Speciality</th>
                <th scope="col">Mobile</th>
                <th scope="col" class="min-width-140">Verification Status</th>
                <th scope="col">Joined on</th>
                <th scope="col">Roles</th>
                <th scope="col">Completed Profiles</th>
                <th scope="col">Last Seen</th>
                <th scope="col" class="min-width-140" s>Branch of Medicine</th>
                <th scope="col">Clinic Name</th>
                <th scope="col">Clinic Address</th>
                <th scope="col" class="min-width-140">Clinic Pin Code</th>
                <th scope="col">Clinic City</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td scope="col" class="table-filter-input min-width-130">
                  <!-- <input
                    class="form-control"
                    label="Search by UUID"
                    placeholder="Search by UUID"
                    v-model="filters.user_id"
                    @input="debounceSearch()"
                  /> -->
                </td>
                <td scope="col" class="table-filter-input min-width-130">
                  <input
                    class="form-control"
                    label="Search by Name"
                    placeholder="Search by Name"
                    v-model="filters.full_name"
                    @input="debounceSearch()"
                  />
                </td>
                <td scope="col" class="table-filter-input">
                  <v-select
                    v-model="filters.specialities"
                    :items="doctorSpecialities"
                    item-text="speciality_type"
                    item-value="speciality_id"
                    outlined
                    multiple
                    placeholder="Select Speciality"
                    @change="getDoctors()"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0" label>
                        <span>{{ item.speciality_type }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filters.specialities.length - 1 }} others)</span
                      >
                    </template>
                  </v-select>
                </td>
                <td scope="col" class="table-filter-input">
                  <input
                    class="form-control"
                    placeholder="Search by mobile no"
                    v-model="filters.mobile"
                    @input="debounceSearch()"
                  />
                </td>
                <td scope="col" class="table-filter-input min-width-140">
                  <v-select
                    v-model="filters.reg_status"
                    :items="['APPROVED', 'PENDING']"
                    outlined
                    placeholder="Select status"
                    @change="getDoctors()"
                  />
                </td>
                <td scope="col" class="table-filter-input">
                  <datepicker
                    v-model="joined_on"
                    @input="getDoctors()"
                    ref="datepicker"
                    :model-config="datePickerConfig"
                    :max-date="new Date()"
                    is-range
                    :masks="{ input: 'DD/MM/YYYY' }"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        :value="
                          !!inputValue.start && !!inputValue.end
                            ? inputValue.start + ' - ' + inputValue.end
                            : 'DD/MM/YYYY'
                        "
                        v-on="inputEvents.start"
                        class="form-control position-relative"
                        placeholder="DD/MM/YYYY"
                      />
                      <div
                        v-if="!!inputValue.start && !!inputValue.end"
                        class="cross-svg"
                        @click="joined_on = { start: '', end: '' }"
                      >
                        <!-- <crossSVG /> -->
                      </div>
                    </template>
                  </datepicker>
                </td>
                <td scope="col" class="table-filter-input">
                  <v-select
                    v-model="filters.roles"
                    :items="[
                      { name: 'Patient', value: 'patient' },
                      { name: 'Doctor', value: 'doctor' },
                      { name: 'Pharmacy', value: 'pharmacy' },
                      { name: 'Diagnostics-lab', value: 'diagnostics-lab' },
                      { name: 'Bloodbank', value: 'bloodbank' },
                      { name: 'Ambulance', value: 'ambulance' },
                    ]"
                    item-text="name"
                    item-value="value"
                    outlined
                    multiple
                    placeholder="Select status"
                    @change="getDoctors()"
                    ><template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" label>
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span v-if="index >= 1" class="grey--text caption"
                        >(+{{ filters.roles.length - 1 }} others)</span
                      >
                    </template>
                  </v-select>
                </td>
                <td scope="col" class="table-filter-input">
                  <v-select
                    v-model="filters.completed_roles"
                    :items="[
                      { name: 'Patient', value: 'patient' },
                      { name: 'Doctor', value: 'doctor' },
                      { name: 'Pharmacy', value: 'pharmacy' },
                      { name: 'Diagnostics-lab', value: 'diagnostics-lab' },
                      { name: 'Bloodbank', value: 'bloodbank' },
                      { name: 'Ambulance', value: 'ambulance' },
                    ]"
                    item-text="name"
                    item-value="value"
                    outlined
                    multiple
                    placeholder="Select status"
                    ><template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" label>
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span v-if="index >= 1" class="grey--text caption"
                        >(+{{
                          filters.completed_roles.length - 1
                        }}
                        others)</span
                      >
                    </template>
                  </v-select>
                </td>
                <td scope="col" class="table-filter-input"></td>
                <td scope="col" class="table-filter-input min-width-140">
                  <v-select
                    v-model="filters.branch"
                    :items="medicineBranches"
                    outlined
                    placeholder="Select Branch of Medicine"
                    multiple
                    @change="getDoctors()"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 1" label>
                        <span>{{ item }}</span>
                      </v-chip>
                      <span v-if="index >= 1" class="grey--text caption"
                        >(+{{ filters.branch.length - 1 }} others)</span
                      >
                    </template>
                  </v-select>
                </td>
                <td scope="col" class="table-filter-input">
                  <input
                    class="form-control"
                    placeholder="Search by clinic name"
                    v-model="filters.clinic_name"
                    @input="debounceSearch()"
                  />
                </td>
                <td scope="col" class="table-filter-input">
                  <input
                    class="form-control"
                    placeholder="Search by address"
                    v-model="filters.address"
                    @input="debounceSearch()"
                  />
                </td>
                <td scope="col" class="table-filter-input min-width-140">
                  <input
                    class="form-control"
                    placeholder="Search by pin code"
                    v-model="filters.pin_code"
                    @input="debounceSearch()"
                  />
                </td>
                <td scope="col" class="table-filter-input">
                  <input
                    class="form-control"
                    placeholder="Search by city"
                    v-model="filters.city"
                    @input="debounceSearch()"
                  />
                </td>
              </tr>
              <tr v-for="(list, i) in doctorList" :key="i">
                <td>
                  <div>{{ list.uuid }}</div>
                </td>
                <td>
                  <div>{{ list.full_name }}</div>
                </td>
                <td>
                  <div>{{ list.speciality ? list.speciality : "&#8213;" }}</div>
                </td>
                <td>
                  <div>{{ list.mobile }}</div>
                </td>
                <td>
                  <div>{{ list.reg_status }}</div>
                </td>
                <td>
                  <div>{{ formatDateTime(list.joined_on) }}</div>
                </td>
                <td>
                  <div>{{ list.roles.join(", ") }}</div>
                </td>
                <td>
                  <div>
                    {{
                      list.completed_profiles.length > 0
                        ? list.completed_profiles.join(", ")
                        : "&#8213;"
                    }}
                  </div>
                </td>
                <td>
                  <div>{{ formatDateTime(list.last_seen) }}</div>
                </td>
                <td>
                  <div>
                    {{
                      list.branch_of_medicine
                        ? list.branch_of_medicine
                        : "&#8213;"
                    }}
                  </div>
                </td>
                <td>
                  <div>
                    {{
                      list.do_not_has_clinic
                        ? "&#8213;"
                        : list.clinic.general.name
                    }}
                  </div>
                </td>
                <td>
                  <div>
                    {{
                      list.do_not_has_clinic
                        ? "&#8213;"
                        : list.clinic.general.address.address_line_two
                    }}
                  </div>
                </td>
                <td>
                  <div>
                    {{
                      list.do_not_has_clinic
                        ? "&#8213;"
                        : list.clinic.general.address.pin_code
                    }}
                  </div>
                </td>
                <td>
                  <div>
                    {{
                      list.do_not_has_clinic
                        ? "&#8213;"
                        : list.clinic.general.address.city
                    }}
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="isEmpty">
              <tr>
                <td colspan="5">
                  <h2 class="text-center">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
      <pagination
        class="mx-3 pagination-block"
        :recordPerPage="recordPerPage"
        :total="total"
        @changePage="changePage"
        v-if="!isEmpty"
      />
    </div>
  </div>
</template>
<script>
import config from "@/config.js";
import { mapGetters } from "vuex";
import formats from "@/formats";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
const loader = () => import("@/components/loader.vue");
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const pagination = () => import("@/views/common/Pagination");
import medicineBranches from "@/data/medicineBranches";
import debounce from "lodash/debounce";
import { pickSvg } from "@/views/SVG";
import dayjs from "dayjs";

export default {
  components: {
    loader,
    Datepicker,
    pagination,
    ...pickSvg("crossSVG ", "calendarSVG"),
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      formats,
      dayJS,
      showLoader: false,
      currentPage: 1,
      recordPerPage: 10,
      totalPage: 0,
      doctorList: [],
      isEmpty: false,
      modalType: "edit",
      doctorSpecialities: [],
      medicineBranches: medicineBranches,
      total: 0,
      joined_on: { start: "", end: "" },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      filters: {
        user_id: "",
        full_name: "",
        specialities: [],
        mobile: "",
        reg_status: "",
        roles: [],
        completed_roles: [],
        last_seen: "",
        joined_on: { start: "", end: "" },
        branch: [],
        clinic_name: "",
        address: "",
        pin_code: "",
        city: "",
      },
    };
  },
  mounted() {
    this.getSpecialities();
    this.getDoctors();
  },
  methods: {
    getSpecialities() {
      let url = `${config.BASE_URL}api/v2/admin/doctor/master/specialities`;
      this.$http.get(url).then((response) => {
        let data = response.body.data;
        this.doctorSpecialities = data.map((text) => {
          text.speciality_type = text.speciality_type
            .toLowerCase()
            .split(" ")
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(" ");

          return text;
        });
      });
    },
    //  page change event call
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getDoctors();
    },
    debounceSearch: debounce(function () {
      this.getDoctors();
    }, 800),
    // getDoctors Data
    getDoctors() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        record_per_page: this.recordPerPage,
      };
      for (const [key, value] of Object.entries(this.filters)) {
        if (typeof value == "string" && value != "") {
          params[key] = value;
        } else if (typeof value == "object" && value.length > 0) {
          params[key] = value;
        }
      }
      if (this.joined_on.start != "" && this.joined_on.end != "") {
        params.joined_on_start_date = dayjs(this.joined_on.start).format(
          "YYYY-MM-DD"
        );
        params.joined_on_end_date = dayjs(this.joined_on.end).format(
          "YYYY-MM-DD"
        );
      }
      let url = `${config.BASE_URL}api/v2/admin/reports/doctor-list`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.doctorList = response.body.data.list;
            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
          } else {
            this.doctorList = [];
            this.isEmpty = true;
          }
        }
      });
    },

    // download current page as csv
    downloadCsv() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        record_per_page: this.recordPerPage,
      };
      for (const [key, value] of Object.entries(this.filters)) {
        if (typeof value == "string" && value != "") {
          params[key] = value;
        } else if (typeof value == "object" && value.length > 0) {
          params[key] = value;
        }
      }
      if (this.joined_on.start != "" && this.joined_on.end != "") {
        params.joined_on_start_date = dayjs(this.joined_on.start).format(
          "YYYY-MM-DD"
        );
        params.joined_on_end_date = dayjs(this.joined_on.end).format(
          "YYYY-MM-DD"
        );
      }
      let url = `${config.BASE_URL}api/v2/admin/reports/doctor-list-csv`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },

    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    formatDateTime(date) {
      return dayJS(date).format(formats.date_time_format);
    },
    formatDate(date) {
      return dayJS(date).format(formats.date_format);
    },
  },
};
</script>
<style lang="scss" scoped>
.table th,
.table td {
  vertical-align: middle;
}
.table-filter-input {
  vertical-align: baseline !important;
}
</style>